import { AfterViewInit, Component, Input, OnInit, ViewChild } from "@angular/core";
import { loadVGSCollect } from "@vgs/collect-js";
import { EventEmitter, Output } from '@angular/core';
import { FormsModule, NgForm, NgModel } from "@angular/forms";
import { CommonModule, NgFor } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";

import { NgbModal, NgbModalModule, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "environments/environment";
import { MatFormFieldControl, MatFormFieldModule, MatLabel } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { Util } from "app/util";
import { MatSelectModule } from "@angular/material/select";
import { InputsModule } from "angular-bootstrap-md";
import { NgxLoadingModule } from "ngx-loading";
import { Subscription } from "rxjs";
import { EventService } from "app/services/event.service";
import { MatTooltip } from "@angular/material/tooltip";
import { scheduledSessionPayment } from "app/models/bookings.model";

@Component({
  selector: "app-cc-payment",
  standalone: true,
  templateUrl: "./cc-payment.component.html",
  styleUrls: ["./cc-payment.component.scss"],
  imports: [
    FormsModule, 
    CommonModule, 
    MatFormFieldModule, 
    MatSelectModule, 
    HttpClientModule, 
    NgbModule, 
    NgbModalModule, 
    MatInputModule, 
    MatIconModule, 
    MatButtonModule, 
    FormsModule, 
    MatFormFieldModule, 
    InputsModule,
    NgxLoadingModule,
    MatTooltip,
  ],
  providers: [
    NgbModal, 
    NgFor
  ]
})
export class CcPaymentsComponent implements OnInit, AfterViewInit {
  public loading: boolean = false;
  @Output() onSuccess = new EventEmitter();
  @Input() payment: scheduledSessionPayment = new scheduledSessionPayment();
  @Input() paymentAmount: number = 0;

  showAppointment: boolean = false;
  showCreditCard: boolean = true;
  showDynamicForm: boolean = false; // Assuming you have another component named Dynamic Form

  nextTopayment() {
    this.showAppointment = false; // Hide the Appointment component
    this.showDynamicForm = true; // Hide the Dynamic Form component
    this.showCreditCard = false; // Show the Credit Card Form component
  }

  vgsForm: any = null;
  vgsState: any = null;
  //Lollypay Payment Method
  selectedLollypayPayment: number = null;
  lollypayPayments: any[] = [];
  @ViewChild('amountN', { static: false }) amountElement: NgModel;
  @ViewChild('addForm') addForm!: NgForm; // Reference to the form
  subs :Subscription = new Subscription();

  constructor(
    private _util: Util,
    private _eventService: EventService,
  ) {
    this.subs.add(
      this._eventService.onBookingSuccessfull.subscribe((event) => {
         this.clearForm();
      })
  );

  this.subs.add(
    this._eventService.onBookClick.subscribe(() => {
        if (this.addForm.form.valid) {
            this.onSuccess.emit({vgsForm:this.vgsForm,vgsState:this.vgsState})
        } else {
            this.addForm.form.markAllAsTouched(); // Mark form as touched to show validation errors
        }
    })
);

  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.setLollypayPayments()
  }

  setLollypayPayments() {
    this.initVgs();
    this.vgsState = null;
    this.lollypayPayments = [];
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  validateVgsForm() {
    return Object.values(this.vgsForm.state).every((field: any) => field.isValid);
  }

  onLollypayPaymentMethodChanged() {
    this.vgsState = null;
    setTimeout(() => {
      this.initVgs();
    }, 100);
  }

  // V3

  async submitCCInfoToVgs() {
    this.loading = true;
    Object.values(this.vgsForm.state).every((field: any, i) => {
      if (!field.isValid) {
        this.loading = false;
        return false;

      }
      if (i === 4) {
        this.submitVgsForm()
          .then((res) => {
            console.log(res)
            this.setDataOfCreditCard(res);
          })
          .catch((err) => {
            this.loading = false;
            this._util.showAlert('danger', err, false);
          });
      }
      return true;
    });

    this.loading = false;
  }

  submitVgsForm() {
    //let api = this.saveCardForFuture ? "/api/cards/persistent" : "/api/cards/volatile"
    return new Promise((resolve, reject) => {
      this.vgsForm.submit(
        '/api/cards/persistent',
        {},
        (status, data) => {
          if (status === 200) {
            console.log('Success');
            console.log('submitVgsForm response: ', data);
            resolve(data);
          }
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  setDataOfCreditCard(data) {

    let exp = data.exp_date.replace(/\s+/g, '');

    if (this.payment){
        this.payment.cvv_code = data.cvv_code;
        this.payment.exp_date = exp
        this.payment.card_number = data.card_number;
        this.payment.card_type =
        this.vgsState.card_number.cardType;
        this.payment.zip_code = data.zip_code;
        this.payment.cardholder_name = data.cardholder_name;
        this.payment.last_four_digit = this.vgsState.card_number.last4;
        this.onSuccess.emit(this.payment);
    }
  }

  initVgs() {
    if (this.vgsForm) this.vgsForm.unmount();
    this.loading = true
    loadVGSCollect(environment.VGS_CONFIG)
      .then((collect: any) => {
        const form = collect.init((state) => {
          this.vgsState = state;
          // this.cdRef.detectChanges();
        });
        this.vgsForm = form;
        // this.loading = false
        setTimeout(()=>{
          this.loading = false
        },1000)
        this.createFields();
      })
      .catch((e) => {
        console.error(
          ' ---------- ERROR While Loading CC Fields with VGS --------- '
        );
        console.error(e);

        // script was not loaded
      });
  }

  createFields() {
    const commonStyles = {
      border: 'none',
      'border-bottom': '1px solid #c4c4c4',
      padding: '0 0 8px 0',
      'font-size': '16px',
      height: '44px', // Fixed height for consistency
      width: '100%', // Ensures inputs take full width of the container
      outline: 'none',
      transition: 'border-color 0.3s ease',
    };

    const focusStyles = {
      ':focus': {
        'border-bottom': '2px solid #6200ea', // Material Design primary color
      },
    };

    const inputStyles = { ...commonStyles, ...focusStyles };

    // Credit Card Name
    this.vgsForm.field('#cc-name .fake-input', {
      type: 'text',
      name: 'cardholder_name',
      placeholder: 'Joe Business',
      validations: ['required'],
      css: inputStyles,
    });

    // Credit Card Number
    this.vgsForm.field('#cc-number .fake-input', {
      type: 'card-number',
      name: 'card_number',
      successColor: '#4F8A10',
      errorColor: '#D8000C',
      placeholder: '4111 1111 1111 1111',
      showCardIcon: true,
      validations: ['required', 'validCardNumber'],
      css: {
        ...inputStyles,
        height: '50px',
        iframe: { height: '60px' }, // Adjust iframe height
        img: {
          // Style specific to the card icon within iframe
          position: 'absolute',
          right: '10px',
          top: '10%',
          transform: 'translateY(-50%)',
        },
      },
    });

    // CVV
    this.vgsForm.field('#cc-cvc .fake-input', {
      type: 'card-security-code',
      name: 'cvv_code',
      placeholder: '344',
      showCardIcon: false,
      validations: ['required', 'validCardSecurityCode'],
      css: {
        ...inputStyles,
        width: '80px', // Adjusted width to prevent overflow
        input: {
          height: '52px', // Set height for input within iframe
        },
        '.cvv-icon': {
          position: 'absolute',
          right: '200px', // Adjust icon positioning within iframe
          top: '50%',
          transform: 'translateY(-50%)',
        },
      },
    });

    // Expiration Date
    this.vgsForm.field('#cc-expiration-date .fake-input', {
      type: 'card-expiration-date',
      name: 'exp_date',
      yearLength: '2',
      placeholder: 'MM/YY',
      validations: ['required', 'validCardExpirationDate'],
      css: { ...inputStyles, width: '100px' }, // Consistent width with CVV for alignment
    });

    // Zip Code
    this.vgsForm.field('#cc-zip .fake-input', {
      type: 'zip-code',
      name: 'zip_code',
      placeholder: 'Zip Code',
      validations: ['required'],
      css: inputStyles,
    });
  }

  onsubmit() {
    this.submitCCInfoToVgs();
  }

  isInvalid() { }

  clearForm(): void {
    if (this.addForm) {
      this.addForm.resetForm(); // Reset Angular form
    }

    if (this.vgsForm && this.vgsForm.reset) {
      this.vgsForm.reset(); // Reset VGS form if applicable
    }
  }
}
